export default function Parchment({ chapter, children }) {
    return (
        <div className="parchment" data-testid="parchment-page">
            <div className="parchment-grain" />
            <div className="relative z-[1] px-6 sm:px-10 lg:px-16 pt-24 md:pt-20 pb-20">
                <div className="max-w-5xl mx-auto">
                    <header className="text-center mb-10 sm:mb-14">
                        <p className="chapter-eyebrow" data-testid="chapter-eyebrow">
                            Capitolo {chapter.numeral}
                        </p>
                        <h1 className="chapter-title mt-3" data-testid="chapter-title">
                            {chapter.label}
                        </h1>
                        <p className="chapter-subtitle mt-3 text-base sm:text-lg">{chapter.subtitle}</p>
                        <div className="flex items-center justify-center gap-3 mt-6" aria-hidden="true">
                            <span className="block h-px w-16 bg-gradient-to-r from-transparent to-[#b08d57]" />
                            <span className="block w-2 h-2 rotate-45 bg-[#b08d57]" />
                            <span className="block h-px w-16 bg-gradient-to-l from-transparent to-[#b08d57]" />
                        </div>
                    </header>
                    {children}
                    <footer className="mt-16 text-center f-detail italic text-sm text-[#8a6d4a]">
                        Tea &amp; Tales Book Club — Storie del tempo e del tè
                    </footer>
                </div>
            </div>
        </div>
    );
}
